import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfigProvider, Form, Input, Spin } from 'antd'
import { Button, Typography, ConfirmModal } from 'mobily-ui-library/lib'

import { orderInquiryApi } from '../../api/api'
import { GlobalContext } from '../../context/GlobalContext'
import './TrackMyOrder.scss'

const TrackMyOrder = () => {
  const [state, dispatch]: any = useContext(GlobalContext)
  const [form] = Form.useForm()
  const { rtl, hashCode, phoneNumber, orderNumber } = state
  const { t } = useTranslation()
  const win: any = window
  const direction = rtl ? 'rtl' : 'ltr'
  var serverURL = win['base_portal_url']
  var errorPage = win['errorPageURL']
  var existingTrackOrderUrl = win['store_order_track']
  const urlParams = new URLSearchParams(window.location.search);

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [phonePatternCheck, setPhonePatternCheck] = useState(false)
  const [trackingNumberCheck, setTrackingNumberCheck] = useState(false)
  const [trackingNumber, setTrackingNumber] = useState<any>(orderNumber ? orderNumber : '')
  const [btnDisabled, setBtnDisabled] = useState(true)

  const phoneNumPattern = /^(((966)([0-9]{9}))||((05)([0-9]{8})))$/
  const trackingNumPattern = /^[ A-Za-z0-9_-]*$/

  console.log("<orderTrack>");

  useEffect(() => {
    let oId: any = urlParams.get('orderId');
    if(oId) {
      setLoading(true);
      orderApiFun(phoneNumber, oId, hashCode);
    } 
  }, []);

  useEffect(() => {
    if(hashCode) {
      setLoading(true);
      const oId = '';
      orderApiFun( phoneNumber, oId, hashCode);
    }
  }, []);

  const handleInputChange = (e: any) => {
    let {value} = e.target;
    const { length } = value
    const validTrackingNum = phoneNumPattern.test(value) || trackingNumPattern.test(value.toLowerCase())
    const phoneNum = value.startsWith('966') || value.startsWith('05')
    const trackingNum = value.toLowerCase().startsWith('es') || value.toLowerCase().startsWith('cem')
    const phoneNumPatternCheck =
      (value.startsWith('966') && length >= 12) || (value.startsWith('05') && length >= 10)

    setTrackingNumber(value.toLowerCase())
    setPhonePatternCheck(phoneNumPatternCheck)
    if (phoneNum) setTrackingNumberCheck(false)
    setTrackingNumberCheck(length >= 7 && !phoneNum)
    length >= 7 && validTrackingNum ? setBtnDisabled(false) : setBtnDisabled(true)
  }

  const handleSubmit = () => {
    const phoneNumber = '';
    const hashCode = '';
    const tNum = trackingNumber.toUpperCase();
    setLoading(true);
    if (tNum.startsWith('ES')) {
      //redirection to existing order track application
      window.location.href = serverURL + existingTrackOrderUrl + '?oId=' + tNum
    } else if (trackingNumber.startsWith('966') || trackingNumber.startsWith('05')) {
      dispatch({
        type: 'TRACK_MY_ORDER_SUCCESS',
        payload: { orderNumber: tNum, phoneNumber: phoneNumber },
      })
      dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OtpScreen' } })
    } else {
      orderApiFun(phoneNumber,tNum, hashCode)
    }
  }

  const orderApiFun = (phoneNumber: any,trackingNumber: any, hashCode: any) => {
    const tNum = trackingNumber.toUpperCase();
    orderInquiryApi(phoneNumber, tNum, hashCode).then((response: any) => {
      if (response.status === 200) {
        setLoading(false);
        dispatch({
          type: 'TRACK_MY_ORDER_SUCCESS',
          payload: {
            orderNumber: tNum,
            inquiryRes: response.data,
          },
        })
        if (hashCode) {
          dispatch({
            type: 'GO_TO_SCREEN',
            payload: { page: 'ListOfOrders' },
          })
        } else {
          dispatch({
            type: 'GO_TO_SCREEN',
            payload: { page: 'OrderDetails' },
          })
        }
      } else if (response.status === 404) { 
        setLoading(false);
        setIsModalVisible(true);
      } else {
        // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
      }
    })
  }

  const handleModal = () => setIsModalVisible(false)

  return loading ? (
    <Spin className="spinLoader" size="large" />
  ) : (
    <div className="trackMyOrder_container" dir={direction}>
      <div className="trackMyOrder_title_container">
        <Typography className="trackMyOrder_title">{t('track_my_order')}</Typography>
        <Typography className="trackMyOrder_subTitle">
          {t('enter_phone_or_tracking_number')}
        </Typography>
      </div>

      <div className="trackMyOrder_formContainer">
        <ConfigProvider direction={direction}>
          <Form form={form} name="control-ref">
            <Form.Item
              className="trackMyOrder_inputField"
              name="trackingNumber"
              initialValue= {trackingNumber}
              rules={[
                {
                  message: t('invalid_phone_number'),
                  pattern: phonePatternCheck ? phoneNumPattern : /.*/s,
                },
                {
                  message: t('invalid_tracking_number'),
                  pattern: trackingNumberCheck ? trackingNumPattern : /.*/s,
                },
              ]}
            >
              <Input
                autoFocus
                bordered={true}
                onChange={(e: any) => handleInputChange(e)}
                maxLength={30}
              />
            </Form.Item>

            <Form.Item className="trackMyOrder_nextButton">
              <Button
                primary={true}
                rtl={rtl}
                variant={btnDisabled ? 'disabled' : 'default'}
                htmlType={'submit'}
                onClick={handleSubmit}
              >
                {t('next')}
              </Button>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>

      <ConfirmModal
        title={t('order_not_found_title')}
        subText={t('order_not_found_subtitle')}
        buttonName={t('got_it')}
        showOutlineButton={false}
        showModal={isModalVisible}
        onClickClose={handleModal}
        onclickButton={handleModal}
      />
    </div>
  )
}

export default TrackMyOrder
